import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "data-test-id", "block", "title", "helpText", "to"];
import { useLocation } from 'react-router-dom';
import styled from 'foundations-theming/utils';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TextHighlight = styled.div.withConfig({
  displayName: "ACNavigatorButton__TextHighlight"
})(["a:hover{text-decoration:none;}&:hover h5{color:", ";}"], ({
  theme
}) => theme.color['text-interactive-default-hover']);
const ACNavigatorButton = _ref => {
  let {
      active,
      'data-test-id': testId,
      block = true,
      title,
      helpText,
      to
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const location = useLocation();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(TextHighlight, Object.assign({
      "data-test-id": testId
    }, props, {
      children: /*#__PURE__*/_jsx(UIRouterButton, {
        block: block,
        to: typeof to === 'string' ? Object.assign({}, location, {
          pathname: to
        }) : to,
        use: "unstyled",
        children: /*#__PURE__*/_jsxs(View, {
          backgroundColor: active ? 'fill-surface-default-pressed' : 'fill-surface-default',
          inlineSize: "100%",
          padding: "600",
          textAlign: "start",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            children: title
          }), helpText && /*#__PURE__*/_jsx(Text, {
            as: "p",
            children: helpText
          })]
        })
      })
    }))
  );
};
export default ACNavigatorButton;